import { useState } from 'react';
import '../App.css';
import USABetTable from './USABetTable';
import Chips from './Chips';
import USAWheel from './USAWheel';

function USATable() {

    const [activeChip, setActiveChip] = useState(1)
    const [wheelSpin, setWheelSpin] = useState(false)
    const [winnerValue, setWinnerValue] = useState(null)
    
    // Estados para manejar los datos de apuestas con estructura inicial completa
    const [numbers, setNumbers] = useState(Array.from({length: 36}, (_, i) => ({
        number: i + 1,
        hover: false,
        values: []
    })))
    
    const [sideValues, setSideValues] = useState([
        { name: '1to18', value: 0 },
        { name: '1st12', value: 0 },
        { name: 'even', value: 0 },
        { name: 'red', value: 0 },
        { name: 'black', value: 0 },
        { name: '2nd12', value: 0 },
        { name: 'odd', value: 0 },
        { name: '19to36', value: 0 },
        { name: '3rd12', value: 0 },
        { name: '2to1_first', value: 0 },
        { name: '2to1_second', value: 0 },
        { name: '2to1_third', value: 0 },
        { name: 'zero', value: 0 },
        { name: 'db_zero', value: 0 }
    ])
    
    return (
        <div className='h-full flex table-bg'>

            <Chips setActiveChip={setActiveChip} activeChip={activeChip} />
            <USABetTable 
                winnerValue={winnerValue} 
                activeChip={activeChip} 
                wheelSpin={wheelSpin}
                numbers={numbers}
                setNumbers={setNumbers}
                sideValues={sideValues}
                setSideValues={setSideValues}
            />
            <USAWheel 
                setWheelSpin={setWheelSpin} 
                winnerValue={winnerValue} 
                setWinnerValue={setWinnerValue}
                numbers={numbers}
                sideValues={sideValues}
            />
        </div>
    );
}

export default USATable;